import React from "react";
import {
  makeStyles,
  Card,
  CardContent,
  Avatar,
  Typography,
  Container,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
  },
  title: {
    padding: "4em 1.2em",
    [theme.breakpoints.only("xs")]: {
      padding: "1em 1.2em",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "448px",
    [theme.breakpoints.down("xs")]: {
      height: "320px",
    },
  },
  pos: {
    marginBottom: 12,
  },
  avatar: {
    display: "flex",
    justifyContent: "center",
  },
  person: {
    padding: ".9em 0",
  },
}));

export default function TestimoninalsCard({ person, msg, avatar, job }) {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent className={classes.content}>
        <Typography variant="h3" color="primary" className={classes.title}>
          {msg}
        </Typography>
        <Container>
          <Container className={classes.avatar}>
            <Avatar alt={person} src={avatar} />
          </Container>
          <Typography
            variant="subtitle1"
            color="primary"
            className={classes.person}
          >
            {person}
          </Typography>
          <Typography
            className={classes.pos}
            variant="subtitle2"
            color="secondary"
          >
            {job}
          </Typography>
        </Container>
      </CardContent>
    </Card>
  );
}
